<template>
  <div>
    <carousel @book="updateBookingDetails"></carousel>
    <booking :bookingDate="bookingDate" :bookingTime="bookingTime"></booking>
    <calendar @book="updateBookingDetails"></calendar>
    <pricing></pricing>
    <about @book="updateBookingDetails"></about>
  </div>
</template>

<script>
import Booking from "@/components/booking/Booking";
import Calendar from "@/components/Calendar";
import Carousel from "@/components/Carousel";
import About from "@/components/About";
import Pricing from "@/components/Pricing";

export default {
  components: {
    Carousel,
    Booking,
    Calendar,
    About,
    Pricing
  },
  data: () => ({
    bookingDate: new Date().toISOString().substr(0, 10),
    bookingTime: ""
  }),
  methods: {
    updateBookingDetails: function(newDate) {
      this.bookingDate = newDate;
      this.bookingTime = Date.now(); // using this to force refresh every time a new date is selected, even if it's the same date
    }
  }
};
</script>
